export function getProperties(node) {
    return node.properties;
}

//# sourceMappingURL=object_.js.map
